import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  constructor(private http:HttpClient) { }


  // addVehicle(data:any){
  //   return this.http.post(environment.apiUrl + "ebck/Vehicle" , data)
  // }

  // getAllVehicle(){
  //  return this.http.get(environment.apiUrl + "ebck/Vehicle/GetAll");
  // }

  getAllVehicle(data){
    return this.http.post(environment.apiUrl + "vehicles/get/pagination" , data);
  }

  updateVehicle(data){
    return this.http.post(environment.apiUrl + "vehicles/update" , data);
  }

  searchVehicle(data){
    return this.http.post(environment.apiUrl + "vehicles/search" , data);
  }
  
  getAllRanges(){
    return this.http.get(environment.apiUrl + "range/get/all")
  }

}
